import gsap from "gsap";

const initializedImages = new WeakSet<HTMLImageElement>();

export const initCeleHeaderAnimations = (root: ParentNode = document): void => {
  root.querySelectorAll<HTMLImageElement>(".cl-header-photo-animate").forEach((image) => {
    if (initializedImages.has(image)) return;

    const section = image.closest<HTMLElement>(".cl-header");
    const contentItems = section
      ? Array.from(section.querySelectorAll<HTMLElement>(".cl-header-content .cl-header-animate"))
      : [];

    initializedImages.add(image);
    gsap.killTweensOf([image, ...contentItems]);

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      gsap.set(image, { autoAlpha: 1, x: 0, willChange: "auto" });
      gsap.set(contentItems, { autoAlpha: 1, x: 0, willChange: "auto" });
      return;
    }

    gsap.set(image, {
      autoAlpha: 0,
      x: 170,
      willChange: "transform,opacity",
    });
    gsap.set(contentItems, {
      autoAlpha: 0,
      x: -60,
      willChange: "transform,opacity",
    });

    const play = (): void => {
      const timeline = gsap.timeline({
        delay: 0.12,
      });

      timeline
        .to(image, {
          autoAlpha: 1,
          duration: 0.2,
          ease: "power1.out",
        }, 0)
        .to(image, {
          x: 0,
          duration: 1,
          ease: "power4.out",
        }, 0)
        .to(contentItems, {
          autoAlpha: 1,
          x: 0,
          duration: 0.62,
          stagger: 0.08,
          ease: "power2.out",
        }, 0.42);
    };

    if (image.complete && image.naturalWidth > 0) {
      requestAnimationFrame(play);
      return;
    }

    image.addEventListener("load", play, { once: true });
  });
};
